// Generated by scripts/generate-product-icon-font.py
export const productIconFontUrl = "/product-lab/assets/material-icons-site-4b69e090f235.woff2";
